module.exports = __webpack_public_path__ + "img/cb-on1.17c38a34.png";